module.exports = __webpack_public_path__ + "0964e2f40dd096c5ec65d8cb554f902d.pdf";